import React from "react";

const WebIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg width="30" height="29" viewBox="0 0 30 29" fill="none" {...props}>
    <path
      d="M28 14.5C28 7.04395 21.9561 1 14.5 1C7.04395 1 1 7.04395 1 14.5C1 21.9561 7.04395 28 14.5 28"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.8511 1.06738C15.8511 1.06738 19.9011 6.39988 19.9011 14.4999M13.1511 27.9324C13.1511 27.9324 9.10106 22.5999 9.10106 14.4999C9.10106 6.39988 13.1511 1.06738 13.1511 1.06738M1.85156 19.2249H14.5011M1.85156 9.77488H27.1506"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.8361 22.4879C28.503 22.8983 28.4612 23.896 27.7754 23.9743L24.3099 24.3671L22.7561 27.4883C22.4483 28.108 21.4965 27.8042 21.3386 27.0374L19.6443 18.7808C19.5107 18.1328 20.0939 17.7251 20.6568 18.0721L27.8361 22.4879Z"
      stroke="#8065C9"
      stroke-width="2"
    />
  </svg>
);

export default WebIcon;
